<template>
  <section v-if="render" class="mc-dashboard__widget">
    <div class="mc-dashboard__widget-header d-flex justify-content-between">
      <div>
        <h4 class="font-size-16 teal-400 mb-1">
          {{ $t('dashboard.title.summaryTripsStatistic') }}
        </h4>
        <p class="font-size-10 teal-400 mb-0">
          {{ periodLabel }}
        </p>
      </div>
      <div>
        <date-picker
          ref="periodMonthPicker"
          v-model="period"
          type="month"
          format="MMM YYYY"
          value-type="YYYY-MM-DD"
          placeholder="Periode"
          :confirm="true"
          :confirm-text="$t('global.action.apply')"
          :disabled-date="disabledRange"
          :lang="datePickerLang"
        >
          <template #footer>
            <b-button class="mx-2" variant="outline-primary" @click="closeCalendar()">
              {{ $t('global.action.cancel') }}
            </b-button>
          </template>
        </date-picker>
      </div>
    </div>
    <div v-if="render" class="mc-dashboard__widget-content">
      <b-row>
        <b-col md="6">
          <TotalSummaryFleet
            :loaded="loaded"
            :datas="tripsStatistics?.data[1]"
            :fleet-types="fleetTypes"
          />
        </b-col>
        <b-col md="6">
          <DriverViolations :loaded="loaded" :datas="tripsStatistics?.data[1]" />
        </b-col>
      </b-row>
    </div>
  </section>
</template>
<script>
import moment from 'moment'
import { Helper } from '@/mixin/helper'
import DriverViolations from './DriverViolations.vue'
import TotalSummaryFleet from './TotalSummaryFleet.vue'
import datePickerLang from '@/helpers/date-picker-lang'
import { GET_TRIPS_STATISTICS } from '@/services/api/dashboard/dashboard'
import { mapGetters } from 'vuex'

moment.locale('id')

export default {
  components: {
    DriverViolations,
    TotalSummaryFleet,
  },
  mixins: [Helper],
  apollo: {
    tripsStatistics: {
      client: 'clientLowPrio',
      query: GET_TRIPS_STATISTICS,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            useNewQuery: this.getFeatureFlagData('optimizeDashboardSummary').value,
            start: {
              month: moment(this.period).locale('en').subtract(1, 'months').format('MMMM'),
              year: Number(moment(this.period).subtract(1, 'months').format('YYYY')),
            },
            end: {
              month: moment(this.period).locale('en').format('MMMM'),
              year: Number(moment(this.period).format('YYYY')),
            },
            ...(this.fleetTypes.length > 0
              ? { vehicleTypeId: this.fleetTypes.map((item) => item.vehicleTypeId) }
              : {}),
            ...(this.fleetGroups.length > 0
              ? { vgroupId: this.fleetGroups.map((item) => item.id) }
              : {}),
            ...(this.branches.length > 0
              ? { companyIds: this.branches.map((item) => item.id) }
              : {}),
          },
        }
      },
      error(error) {
        if (error.networkError && error.networkError.statusCode === 504) {
          this.$mcToast.error(this.$t('global.somethingWentWrong'))
        }
      },
      result({ data, loading }) {
        if (!loading) {
          this.tripsStatistics = data.tripsStatistics.tripsStatistics
          this.render = true

          setTimeout(() => {
            this.loaded = true
          }, 500)
        } else {
          this.loaded = false
        }
      },
      watchLoading(loading) {
        if (loading) {
          this.loaded = false
        }
      },
    },
  },
  props: ['fleetGroups', 'fleetTypes', 'mainPeriod', 'branches'],

  data() {
    return {
      period: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      periodLabel: null,
      tripsStatistics: null,
      loaded: false,
      render: true,
    }
  },
  computed: {
    datePickerLang() {
      return datePickerLang()
    },
    ...mapGetters({
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),
  },
  watch: {
    mainPeriod: {
      handler() {
        this.period = this.mainPeriod
        const month = this.localizeMonth(moment(this.period).format('MMMM'))
        const year = moment(this.period).format('YYYY')
        this.periodLabel = `${month} ${year}`
      },
    },
    period: {
      handler() {
        const month = this.localizeMonth(moment(this.period).format('MMMM'))
        const year = moment(this.period).format('YYYY')
        this.periodLabel = `${month} ${year}`
        setTimeout(() => {
          this.loaded = false
        }, 500)
      },
    },
    fleetGroups: {
      handler() {
        this.loaded = false
      },
    },
    fleetTypes: {
      handler() {
        this.loaded = false
      },
    },
    branches: {
      handler() {
        this.loaded = false
      },
      deep: true,
    },
    '$i18n.locale': function () {
      this.render = false
      const month = this.localizeMonth(moment(this.period).format('MMMM'))
      const year = moment(this.period).format('YYYY')
      this.periodLabel = `${month} ${year}`
      setTimeout(() => {
        this.render = true
      }, 500)
    },
  },
  mounted() {
    const month = this.localizeMonth(moment(this.period).format('MMMM'))
    const year = moment(this.period).format('YYYY')
    this.periodLabel = `${month} ${year}`
  },
  methods: {
    openDatepicker() {
      this.$refs.periodMonthPicker.openPopup()
    },
    closeCalendar() {
      this.$refs.periodMonthPicker.defaultOpen = false
    },
    disabledRange: function (date) {
      return date >= moment().subtract(1, 'months').endOf('month')
    },
    pickDate(date) {
      const month = this.localizeMonth(moment(date).format('MMMM'))
      const year = moment(date).format('YYYY')
      this.periodLabel = `${month} ${year}`
    },
    openModal() {
      this.$bvModal.show(this.ids)
    },
  },
}
</script>
